import React, { useState } from "react";
import { Tooltip, IconButton, Typography } from "@mui/material";
import {
  ContentCopy as CopyIcon,
  Check as CheckIcon,
} from "@mui/icons-material";
import { LANG } from "./constants";

const CopyButton = ({ text, lang }) => {
  const [copied, setCopied] = useState(false);

  const handleCopy = () => {
    navigator.clipboard.writeText(text).then(() => {
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    });
  };

  return (
    <Tooltip
      title={copied ? lang?.copied || LANG.copied : lang?.copy || LANG.copy}
    >
      <IconButton
        size="small"
        onClick={handleCopy}
        sx={{
          display: "flex",
          gap: 0.5,
          borderRadius: 1.5,
          px: 1,
          py: 0.5,
          color: copied ? "success.main" : "text.disabled",
          "&:hover": {
            bgcolor: "action.hover",
            color: copied ? "success.main" : "text.secondary",
          },
          transition: "all 0.15s",
        }}
      >
        {copied ? (
          <CheckIcon sx={{ fontSize: 14 }} />
        ) : (
          <CopyIcon sx={{ fontSize: 14 }} />
        )}
        <Typography
          component="span"
          sx={{
            fontSize: "0.72rem",
            fontWeight: 600,
            color: "inherit",
            lineHeight: 1,
          }}
        >
          {copied ? lang?.copied || LANG.copied : lang?.copy || LANG.copy}
        </Typography>
      </IconButton>
    </Tooltip>
  );
};

export default CopyButton;
